// Default milestone / payment-plan templates seeded into the `plans` table
// when it is empty. Each milestone stores a fixed % of the sale value; the
// rupee amount is computed per booking as saleValue * pct / 100.

const ord = (n) => {
  const s = ["th", "st", "nd", "rd"], v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
};

// ---- Rohan Nest (G+3, 25 milestones) ----
const nest = [
  ["Booking & Documentation", "On booking / application money", 5],
  ["Booking & Documentation", "On execution of Agreement for Sale", 7],
  ["Booking & Documentation", "On commencement of excavation", 3],
  ["Foundation & Sub-structure", "On completion of excavation & earthwork", 4],
  ["Foundation & Sub-structure", "On completion of foundation footings & raft", 5],
  ["Foundation & Sub-structure", "On completion of plinth beams / ground floor level", 4],
  ["Superstructure (RCC)", "On casting of ground floor columns", 3],
  ["Superstructure (RCC)", "On casting of ground floor roof slab", 6],
  ["Superstructure (RCC)", "On casting of 1st floor roof slab", 6],
  ["Superstructure (RCC)", "On casting of 2nd floor roof slab", 6],
  ["Superstructure (RCC)", "On casting of 3rd floor (terrace) roof slab", 6],
  ["Block Masonry", "On block masonry of ground & 1st floors", 4],
  ["Block Masonry", "On block masonry of 2nd & 3rd floors", 4],
  ["Plastering", "On internal plastering of all floors", 4],
  ["Plastering", "On external plastering", 4],
  ["Plastering", "On ceiling plaster, POP cornice & putty base", 2],
  ["MEP Rough-in", "On completion of plumbing & drainage rough-in", 3],
  ["MEP Rough-in", "On completion of electrical conduiting & wiring rough-in", 3],
  ["Flooring & Tiling", "On waterproofing & tiling of bathrooms & kitchens", 3],
  ["Flooring & Tiling", "On vitrified flooring of all units", 3],
  ["Flooring & Tiling", "On flooring of common areas & staircases", 2],
  ["Doors, Fixtures & Painting", "On fixing of doors, windows, sanitary ware & CP fittings", 3],
  ["Doors, Fixtures & Painting", "On completion of internal & external painting", 2],
  ["Possession & Handover", "On installation of lifts, common amenities & receipt of OC", 3],
  ["Possession & Handover", "On possession, registration of Sale Deed & handover", 5],
].map(([stage, label, pct]) => ({ stage, label, pct }));

// ---- Rohan City (high-rise, 75 milestones) ----
const city = [];
const add = (stage, label, pct) => city.push({ stage, label, pct });

add("Booking & Documentation", "On booking / application money", 5);
add("Booking & Documentation", "Within 30 days of booking", 3);
add("Booking & Documentation", "On execution of Agreement for Sale", 2);
add("Booking & Documentation", "On commencement of excavation", 1);

add("Foundation & Sub-structure", "On completion of excavation & earthwork", 1.5);
add("Foundation & Sub-structure", "On completion of pile foundation", 1.5);
add("Foundation & Sub-structure", "On completion of raft / mat foundation", 2);
add("Foundation & Sub-structure", "On completion of plinth beams & ground floor level", 1.5);
add("Foundation & Sub-structure", "On completion of retaining walls", 1);
add("Foundation & Sub-structure", "On casting of columns up to ground floor", 1.5);

add("Superstructure (RCC)", "On casting of Ground floor roof slab", 1.5);
add("Superstructure (RCC)", "On casting of 1st floor roof slab", 1.5);
add("Superstructure (RCC)", "On casting of 2nd floor roof slab", 1.5);
add("Superstructure (RCC)", "On casting of 3rd floor roof slab", 1.5);
add("Superstructure (RCC)", "On casting of 4th floor (residential parking) slab", 1);
add("Superstructure (RCC)", "On casting of 5th floor (residential parking) slab", 1);
add("Superstructure (RCC)", "On casting of 6th floor (City Club) slab", 1);
for (let fl = 7; fl <= 28; fl++) add("Superstructure (RCC)", `On casting of ${ord(fl)} floor roof slab`, 1);

add("Block Masonry", "On block masonry of commercial floors (GF-2nd)", 1.5);
add("Block Masonry", "On block masonry of parking & club floors (3rd-6th)", 1.5);
add("Block Masonry", "On block masonry of residential 7th-13th floors", 1.5);
add("Block Masonry", "On block masonry of residential 14th-20th floors", 1.5);
add("Block Masonry", "On block masonry of residential 21st-28th floors", 1.5);
add("Block Masonry", "On completion of internal partition walls", 1.5);

add("Internal Plastering", "On internal plastering of 7th-13th floors", 1.5);
add("Internal Plastering", "On internal plastering of 14th-20th floors", 1.5);
add("Internal Plastering", "On internal plastering of 21st-28th floors", 1.5);
add("Internal Plastering", "On internal plastering of commercial & podium floors", 1);
add("Internal Plastering", "On completion of ceiling plaster & POP cornice", 1.5);

add("External Plaster & Facade", "On external plastering of lower zone (up to 14th floor)", 1.5);
add("External Plaster & Facade", "On external plastering of upper zone (15th-28th floor)", 1.5);
add("External Plaster & Facade", "On completion of facade glazing & honeycomb cladding", 1);

add("MEP Rough-in", "On completion of plumbing & drainage rough-in", 1.5);
add("MEP Rough-in", "On completion of electrical conduiting & wiring rough-in", 1.5);
add("MEP Rough-in", "On completion of reticulated gas piping", 1);
add("MEP Rough-in", "On completion of fire-fighting & sprinkler rough-in", 1);

add("Flooring & Tiling", "On waterproofing & tiling of bathrooms & kitchens", 1.5);
add("Flooring & Tiling", "On vitrified flooring of residential 7th-17th floors", 1.5);
add("Flooring & Tiling", "On vitrified flooring of residential 18th-28th floors", 1.5);
add("Flooring & Tiling", "On flooring of common areas & staircases", 0.5);

add("Doors, Fixtures & Painting", "On fixing of door & window frames and shutters", 1.5);
add("Doors, Fixtures & Painting", "On installation of sanitary ware & CP fittings", 1);
add("Doors, Fixtures & Painting", "On completion of internal painting (putty + emulsion)", 1.5);
add("Doors, Fixtures & Painting", "On completion of external painting", 1);

add("Lifts, Amenities & City Club", "On installation & testing of passenger & service elevators", 1.5);
add("Lifts, Amenities & City Club", "On completion of City Club fit-out & amenities", 1.5);
add("Lifts, Amenities & City Club", "On completion of landscaping, play area & rooftop deck", 1);

add("External Development", "On commissioning of STP, WTP & rainwater harvesting", 1);
add("External Development", "On commissioning of DG sets, transformer & solar PV", 1);
add("External Development", "On completion of compound wall, gate, roads & paving", 1);

add("Possession & Handover", "On receipt of Occupancy Certificate (OC)", 2);
add("Possession & Handover", "On intimation of possession", 2);
add("Possession & Handover", "On registration of Sale Deed", 2);
add("Possession & Handover", "On handover of keys / final settlement", 1);

export const MILESTONE_SEED = [
  {
    id: 1, name: "Rohan Nest", location: "Attavar-Babugudda, Mangaluru", rera: "PRM/KA/RERA/1257/334/PR/180625/007847",
    bank: { beneficiary: "ROHAN CORPORATION INDIA PVT LTD RERA A/C ROHAN NEST", name: "KARNATAKA BANK LTD", acc: "4752000100160207", ifsc: "KARB0000475", branch: "FOUNDERS BRANCH, DONGERKERY MANGALORE" },
    milestones: nest,
  },
  {
    id: 2, name: "Rohan City", location: "Bejai Main Road, Mangaluru", rera: "PRM/KA/RERA/1257/334/PR/211122/005492",
    bank: { beneficiary: "ROHAN CORPORATION INDIA PVT LTD RERA A/C ROHAN CITY", name: "KARNATAKA BANK LTD", acc: "4752000100159301", ifsc: "KARB0000475", branch: "FOUNDERS BRANCH, DONGERKERY MANGALORE" },
    milestones: city,
  },
];
